export default __webpack_public_path__ + "static/media/yellowPlay.d2cbdaa2.svg";